<template>
  <div id="Information" class="full_layout information">
    <h3 class="informationTitle">达咖平台用户服务协议</h3>
    <div class="informationBox">
      <div>本协议是您与达咖平台所有者即上海达咖文化发展有限公司之间就达咖平台服务等相关事宜所订立的合同，<span class="line strong">上海达咖文化发展有限公司（以下简称“达咖”）在此特别提醒：在您注册成为用户（以下简称“用户”或“您”）之前，请您仔细阅读本达咖平台用户服务协议（以下简称“本协议”），特别是免除或者限制责任的条款、法律适用条款和争议解决条款等以粗体划线重点标识的条款。</span>如果您对本协议的内容有任何疑问，请向达咖平台的客服咨询。</div>
      <div>当您阅读并同意本协议、按要求填写信息且您点击"同意并注册"按钮、完成全部注册程序后，即表示您已充分理解并接受本协议的全部内容，并与达咖就本协议达成一致，本协议即构成对双方有约束力的法律文件，您成为达咖平台的“用户”。如果您不同意本协议或其中任何条款约定，您应立即停止注册。</div>
      <ul class="useragreement">
        <li>
          <div class="t1">第 1 条 本平台服务条款的确认和接纳</div>
          <dl>
            <dt>1.1</dt>
            <dd>本平台的各项电子服务的所有权和运作权归达咖所有。用户同意所有用户服务协议条款并完成注册程序，表示用户已充分理解并接受本协议的全部内容，并与达咖就本协议达成一致，才能成为本平台的正式用户。用户确认：本协议条款是处理双方权利义务的契约，始终有效，法律另有强制性规定或双方另有特别约定的，依其规定。</dd>
            <dt>1.2</dt>
            <dd>用户点击同意本协议的，即视为用户确认自己具有享受本平台服务、下单购物等相应的权利能力和行为能力，能够独立承担法律责任。</dd>
            <dt>1.3</dt>
            <dd class="line strong">如果您在18周岁以下，您只能在父母或监护人的监护和同意参与下才能使用本平台。</dd>
            <dt>1.4</dt>
            <dd class="line strong">达咖保留在中华人民共和国大陆地区施行之法律允许的范围内独自决定拒绝服务、关闭用户账户、清除或编辑内容或取消订单的权利。</dd>
          </dl>
        </li>
        <li>
          <div class="t1">第 2 条 本平台服务</div>
          <dl>
            <dt>2.1</dt>
            <dd>达咖平台是达咖开发、运营和管理的旨在提供网络经营场所供买家购买平台上所售物品的软件产品，达咖平台通过互联网依法在平台展示商品/服务信息、寻找交易对象并完成商品交易，用户在完全同意本协议及本平台规定的情况下，方有权使用本平台的相关服务。</dd>
            <dt>2.2</dt>
            <dd>达咖有权在达咖平台随时强化现有功能或增加任何新功能，包括但不限于在达咖平台上推出新的服务内容；除非达咖平台在用户注册同意时的功能遭到删减导致用户不能使用该平台功能的，否则用户不能对达咖平台功能的强化和增加提出异议。</dd>
            <dt>2.3</dt>
            <dd>用户必须自行准备如下设备和承担如下开支：</dd>
            <dd>1. 上网设备，包括并不限于电脑或者其他上网终端、调制解调器及其他必备的上网装置。</dd>
            <dd>2. 上网开支，包括并不限于网络接入费、上网设备租用费、手机流量费等。</dd>
            <dt>2.4</dt>
            <dd>达咖平台提供的服务中可能包括广告，用户同意在使用过程中显示达咖平台和第三方供应商、合作伙伴提供的广告。除法律法规明确规定外，用户应自行对依该广告信息进行的交易负责，对用户因依该广告信息进行的交易或前述广告商提供的内容而遭受的损失或损害，达咖平台不承担任何责任。</dd>
            <dt>2.5</dt>
            <dd>达咖平台仅为用户提供内容存储空间，无法控制经由本协议项下的服务传送之内容，因此不保证内容的正确性、完整性或品质。您已预知使用本协议项下的服务时，可能会接触到令人不快、不适当或令人厌恶之内容。在任何情况下，达咖平台均不为任何内容负责，但达咖平台有权依法停止传输任何前述内容并采取相应行动，包括但不限于暂停用户使用本协议项下的服务的全部或部分，保存有关记录，并向有关机关报告。</dd>
          </dl>
        </li>
        <li>
          <div class="t1">第 3 条 用户信息</div>
          <dl>
            <dt>3.1</dt>
            <dd class="line strong">用户应自行诚信地向本平台提供注册资料，用户同意其提供的注册资料真实、准确、完整、合法有效，用户注册资料如有变动的，应及时更新其注册资料。如果用户提供的注册资料不合法、不真实、不准确、不完整的，用户需承担因此引起的相应责任及后果，并且达咖保留终止用户使用达咖平台各项服务的权利。</dd>
            <dd class="line strong">达咖平台仅允许每位用户申请注册一个账号，如有证据证明或达咖根据达咖平台规则判断您不当申请注册或不当使用多个达咖平台账号的，达咖平台有权采取冻结或注销账号、取消订单或拒绝提供服务等措施。如给达咖平台及相关方造成损失的，您应承担赔偿责任</dd>
            <dt>3.2</dt>
            <dd>用户在使用达咖平台服务时，用户应当在达咖平台完成实名认证，应按照达咖平台页面的提示准确完整地提供您的信息（包括您的姓名及电子邮件地址、联系电话、联系地址等），以便达咖或其他用户与您联系。您了解并同意，您有义务保持您提供信息的真实性及有效性。</dd>
            <dd>涉及用户真实姓名/名称、通信地址、联系电话、电子邮箱等隐私信息的，本平台将予以严格保密，除非得到用户的授权或法律另有规定，本平台不会向外界披露用户隐私信息。</dd>
            <dt>3.3</dt>
            <dd>用户注册成功后，将产生用户名和密码等账户信息，您可以根据本平台规定改变您的密码。用户应谨慎合理的保存、使用其用户名和密码，如果由于您未谨慎合理的保存、使用自己的用户名和密码而对您或第三方造成任何损失或损害，达咖平台无法也不承担任何法律责任。 用户若发现任何非法使用用户账号或存在安全漏洞的情况，请立即通知本平台并向公安机关报案，达咖平台将在行政或司法机关的要求下提供必要的配合及协助。</dd>
            <dd class="line strong">由于您的达咖平台账户关联您的个人信息及达咖平台商业信息，您的达咖平台账户仅限您本人使用。未经达咖平台同意，您直接或间接授权第三方使用您达咖平台账户或获取您账户项下信息的行为无效。如达咖根据达咖平台规则中约定的违约认定程序及标准判断您达咖平台账户的使用可能危及您的账户安全及/或达咖平台信息安全的，达咖平台可拒绝提供相应服务或终止本协议。</dd>
            <dt>3.4</dt>
            <dd>若用户提供任何违法、无效的信息，或提供违法、侵权、不道德或达咖平台认为不适合在平台上展示的资料，或者达咖平台有理由怀疑您的资料属于程序或恶意操作，达咖平台有权注销您的账号、取消您的订单、拒绝您于现在和未来使用达咖平台服务的全部或任何部分或采取其他合理措施。如给达咖平台造成损失的，您应承担赔偿责任。</dd>
            <dt>3.5</dt>
            <dd>用户应对账户下的所有行为及结果负责，包括但不限于签署各类协议、发布信息、购买商品或服务及披露信息等。</dd>
            <dt>3.6</dt>
            <dd class="line strong">未经平台许可，账号初始申请注册人不得赠予、借用、租用、转让或售卖达咖账号或者以其他方式许可其他主体使用达咖账号，非初始申请注册人不得通过受赠、继承、承租、受让或者其他任何方式使用达咖账号。一经核实，达咖平台有权作出独立判断并采取包括但不限于取消交易订单、注销用户账号、扣除账户余额等措施。</dd>
            <dt>3.7</dt>
            <dd>您的账户为您自行设置并由您保管，达咖任何时候均不会主动要求您提供您的账户密码。因此，建议您务必保管好您的账户，并确保您在每个上网时段结束时退出登录并以正确步骤离开达咖平台。</dd>
            <dd class="line strong">账户因您主动泄露或因您遭受他人攻击、诈骗等行为导致的损失及后果，达咖并不承担责任，您应通过司法、行政等救济途径向侵权行为人追偿。</dd>
            <dt>3.8</dt>
            <dd>用户不得开发或委托第三方开发/使用应用程序侵入达咖平台进行批量数据抓取、下载，达咖平台明令禁止任何数据抓取行为。如达咖平台发现您实施了上述行为，则有权注销您的账户并扣除您的全部资金，拒绝您于现在和未来使用达咖平台服务的全部功能，并就达咖及达咖平台遭受的全部损失要求您承担赔偿责任。</dd>
            <dt>3.9</dt>
            <dd>用户同意，达咖拥有通过邮件、电话短信等形式，向在本平台注册、购物的用户发送订单信息、促销活动等告知信息的权利。</dd>
            <dt>3.10</dt>
            <dd>用户知晓，当用户或用户委托的律师持有法院的调查令时，达咖有权使用用户的注册信息、用户名、密码等信息，登录进入用户的注册账户，进行调查令所要求的证据保全。</dd>
            <dt>3.11</dt>
            <dd>用户应当及时更新用户提供的信息，在法律有明确规定要求达咖作为平台服务提供者必须对部分用户的信息进行核实的情况下，达咖将依法不时地对用户的信息进行检查核实，用户应当配合提供最新、真实、完整、有效的信息。</dd>
            <dd class="line strong">如达咖按用户最后一次提供的信息与用户联系未果、用户未按达咖的要求及时提供信息、用户提供的信息存在明显不实或行政司法机关核实用户提供的信息无效的，用户将承担因此对自身、他人及达咖造成的全部损失与不利后果。达咖可向用户发出询问或要求整改的通知，并要求用户进行重新认证，直至中止、终止对用户提供部分或全部达咖平台服务，达咖对此不承担责任。</dd>
          </dl>
        </li>
        <li>
          <div class="t1">第 4 条 用户依法言行义务</div>
          <p>本协议依据国家相关法律法规规章制定，用户同意严格遵守以下义务：</p>
          <dl>
            <dt>4.1</dt>
            <dd>用户应确保通过达咖平台提交、制作、上载、复制、发布、传播的全部信息(包括但不限于个人信息、商品信息、言论及所作出的行为或事件)不含如下内容:：煽动抗拒、破坏宪法和法律、行政法规实施的；煽动颠覆国家政权，推翻社会主义制度的；煽动分裂国家、破坏国家统一的；煽动民族仇恨、民族歧视、破坏民族团结的；破坏国家宗教政策、宣扬邪教和封建迷信的；谣言，扰乱社会秩序破坏社会稳定的；淫秽色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；侮辱或者诽谤他人、侵害他人合法权益的；其他含有法律、行政法规禁止的其他内容的信息。</dd>
            <dt>4.2</dt>
            <dd>用户不得利用达咖平台的账户或本协议项下的服务制作、上载、复制、发布、传播如下干扰达咖平台的正常运营,以及侵犯其他用户或第三方合法权益的内容：
              <p>（1）含有任何性或性暗示的;</p>
              <p>（2）含有辱骂、恐吓、威胁內容的;</p>
              <p>（3）含有强扰、垃圾广告、恶意信息、诱骗信息的;</p>
              <p>（4）涉及他人隐私、个人信息或资料的;</p>
              <p>（5）侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的;</p>
              <p>（6）含有其他干扰本服务正常运营和侵犯其他用户或第三方合法权益内容的信息。</p>
            </dd>
            <dt>4.3</dt>
            <dd>用户不得利用达咖平台的账户或本协议项下的服务或利用本平台功能或在本平台上进行如下行为:
              <p>（1）利用达咖平台从事洗钱、窃取商业秘密、窃取个人信息等违法犯罪活动；</p>
              <p>（2）干扰达咖平台的正常运转，侵入达咖平台及国家计算机信息系统；</p>
              <p>（3）利用在达咖平台注册的账户进行非法牟利性经营活动；</p>
              <p>（4）提交、发布虚假信息，或盗用他人头像或资料，冒充、利用他人名义的；</p>
              <p>（5）强制、诱导其他用户关注、点击链接页面或分享信息的；</p>
              <p>（6）利用技术手段批量建立虚假账号的；</p>
              <p>（7）利用平台漏洞虚假交易、刷单、套现等获取不正当利益的行为；</p>
              <p>（8）教唆他人从事本条所禁止的行为；</p>
              <p>（9）制作、发布与以上行为相关的方法、工具，或对此类方法、工具进行运营或传播,无论这些行为是否为商业目的；</p>
              <p>（10）其他违反法律法规规定、侵犯其他用户合法权益、干扰达咖平台正常运营或达咖平台未明示授权的行为。</p>
            </dd>
            <dd>达咖平台经过审慎的分析、识别后，有合理理由认为您涉嫌洗钱、虚假交易、刷单等上述违规行为的，达咖平台有权采取拒绝您使用达咖平台服务、注销该账号等措施，且达咖平台将直接报警处理。</dd>
            <dt>4.4</dt>
            <dd>用户在达咖平台从中国大陆向境外传输资料信息时必须符合中国有关法规。</dd>
            <dt>4.5</dt>
            <dd>用户须对利用达咖平台账户或本协议项下的服务传送信息的真实性、合法性、无害性、准确性、有效性等全权负责，与用户所传播的信息相关的任何法律责任由用户自行承担，与达咖平台无关。如因此给达咖平台或第三方造成损害的，用户应当依法予以赔偿。</dd>
            <dt>4.6</dt>
            <dd class="line strong">用户应关注并遵守本平台不时公布或修改的各类合法规则规定。</dd>
            <dd class="line strong">本平台保有删除站内各类不符合法律政策或不真实的信息内容而无须通知用户的权利，为确保本平台的正常运营，本平台有权对不符合法律政策或不真实的信息内容作出独立判断，用户不得对此提出异议。</dd>
            <dd class="line strong">若用户未遵守以上规定的，本平台有权作出独立判断并采取包括但不限于关闭交易订单、冻结或注销用户账号、扣除账户余额等措施。情节严重的，达咖平台有权移交司法机关处理。用户须对自己在网上的言论和行为承担法律责任。</dd>
          </dl>
        </li>
        <li>
          <div class="t1">第 5 条 商品信息</div>
          <p>本平台上的商品价格、数量、是否有货等商品信息随时都有可能发生变动，本平台不作特别通知。由于平台上商品信息的数量极其庞大，虽然本平台会尽最大努力保证您所浏览商品信息的准确性，但由于众所周知的互联网技术因素等客观原因存在，本平台上显示的信息可能会有一定的滞后性或差错，对此情形您知悉并同意；达咖欢迎纠错，并会视情况给予纠错者一定的奖励；但任何时候，达咖平台不因网页显示信息的滞后性或差错对用户承担赔偿损失等法律责任。</p>
        </li>
        <li>
          <div>第 6 条 订单</div>
          <dl>
            <dt>6.1</dt>
            <dd>在您下订单时，请您仔细确认所购商品的名称、价格、数量、型号、规格、尺寸、联系地址、电话、收货人等信息。收货人与用户本人不一致的，收货人的行为和意思表示视为用户的行为和意思表示，用户应对收货人的行为及意思表示的法律后果承担连带责任。</dd>
            <dt>6.2</dt>
            <dd>您应当在拍下商品后及时付款，您自拍下商品之时起24小时内未付款的，交易将自动关闭。</dd>
            <dt>6.3</dt>
            <dd>您可基于真实的交易在交易成功后15日内发布与交易商品或服务相关的信息，对该笔交易开展评价。为确保评价内容能为其他消费者购物决策提供可靠的依据，反映商品或服务的真实情况，您的评价应当与交易的商品或服务具有关联性，且合法、客观、真实，您不得利用达咖平台评价工具侵害相关方合法权益，否则达咖平台针对违规评论可采取屏蔽评论内容等措施，针对违规买家可采取限制使用达咖平台服务等措施。</dd>
            <dt>6.4</dt>
            <dd>您对商品或服务存在争议的，应当在交易成功后的72小时内通过订单页面发起维权申请。以下几种情形不受受理时效的限制：
              <p>（一）行政机关认定为假冒或违禁商品；</p>
              <p>（二）买家提供司法机关出具的生效法律文书；</p>
              <p>（三）买家未在达咖规定的时限内在线发起维权，但能够提供凭证证实未收到货、商品存在品质等相关问题。</p>
            </dd>
            <dt>6.5</dt>
            <dd>您在达咖平台交易过程中与平台方或其他用户发生争议的，您或其他用户中任何一方均有权选择以下途径解决：
              <p>（一）与争议相对方自主协商；</p>
              <p>（二）使用达咖平台提供的订单维权调处服务；</p>
              <p>（三）请求消费者协会或者其他依法成立的调解组织调解；</p>
              <p>（四）向有关行政部门投诉；</p>
              <p>（五）根据与争议相对方达成的仲裁协议（如有）提请仲裁机构仲裁；</p>
              <p>（六）向人民法院提起诉讼。</p>
            </dd>
            <dd>如您依据达咖平台规则使用达咖平台的订单维权调处服务，则表示您认可并愿意履行达咖平台的客服根据所了解到的争议事实并根据达咖平台规则所作出的调处决定（包括调整相关订单的交易状态、判定将争议款项的全部或部分支付给交易一方或双方等）。在达咖平台调处决定作出前，您可选择上述（三）、（四）、（五）、（六）途径（下称“其他争议处理途径”）解决争议以中止达咖平台的订单维权调处服务。<span class="line strong">如您对调处决定不满意，您仍有权采取其它争议处理途径解决争议，但通过其他争议处理途径未取得终局决定前，您仍应先履行调处决定。</span></dd>
            <dd class="line strong">您理解并同意，在订单维权调处服务中，达咖平台的客服并非专业人士，仅能以普通人的认知对用户提交的凭证进行判断。因此，除存在故意或重大过失外，调处方对争议调处决定免责。</dd>
            <dd class="line strong">除法律另有强制性规定外，双方约定如下：当平台方出售商品、买家提交订单并付款后,买卖合同即告成立。因买家违约取消订单的,达咖平台将收取一定的违约金作为平台方的补偿，您可以随时登录您在本平台注册的账户，查询您的订单状态。</dd>
          </dl>
        </li>
        <li>
          <div class="t1">第 7 条 配送</div>
          <dl>
            <dt>7.1</dt>
            <dd>买家付款后，达咖平台根据自身的服务能力在平台规定的时效内，采用适当的发货方式履行发货义务。达咖平台应在买家付款后72小时内发货或设置的发货时间内发货，达咖平台官方发起的活动、特定节假日、疫情影响等情形，发货时间以达咖平台的公告通知为准。</dd>
            <dt>7.2</dt>
            <dd>您所订购的商品的配送方式为：（1）由达咖平台选择具有运输服务资质的公司为您提供运输代理服务；（2）商品运输的费用由买家承担。</dd>
            <dt>7.3</dt>
            <dd class="line strong">因如下情况造成订单延迟或无法配送等，达咖平台不承担延迟配送的责任：
              <p>· 用户提供的信息错误、地址不详细等原因导致的；</p>
              <p>· 货物送达后无人签收，导致无法配送或延迟配送的；</p>
              <p>· 情势变更因素导致的；</p>
              <p>· 不可抗力因素导致的，例如：自然灾害、疫情管控、交通戒严、突发战争等。</p>
            </dd>
          </dl>
        </li>
        <li>
          <div class="t1">第 8 条 数据储存</div>
          <dl>
            <dt>8.1</dt>
            <dd>达咖平台不对用户在本协议项下的服务中相关数据的删除或储存失败负责。</dd>
            <dt>8.2</dt>
            <dd>达咖平台在中华人民共和国境内的运营业务收集或产生的数据均存储在中华人民共和国境内服务器。</dd>
            <dt>8.3</dt>
            <dd>商品和服务信息、交易信息保存时间自交易完成之日起不少于三年。达咖平台可以根据实际情况依法自行决定用户在本协议项下的服务中数据的最长储存期限，并在服务器上为其分配数据最大存储空间等。用户可根据自己的需要自行备份本协议项下的服务中的相关数据。</dd>
          </dl>
        </li>
        <li>
          <div class="t1">第 9 条 所有权及知识产权条款</div>
          <dl>
            <dt>9.1</dt>
            <dd>用户一旦接受本协议，即表明该用户主动将其在任何时间段在本平台发表的任何形式的信息内容（包括但不限于客户评价、客户咨询、各类话题文章等信息内容）的财产性权利等任何可转让的权利，如著作权财产权（包括并不限于：复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权以及应当由著作权人享有的其他可转让权利），在全球范围内、免费的、独家的、可授权的、不可撤销地转让给达咖所有，用户同意达咖有权以公司名义就任何主体侵权而单独提起诉讼。</dd>
            <dt>9.2</dt>
            <dd>本协议已经构成《中华人民共和国著作权法》第二十七条（条文序号依照2020年修正版著作权法确定）及相关法律规定的著作财产权等权利转让书面协议，其效力及于用户在达咖平台上发布的任何受著作权法保护的作品内容，无论该等内容形成于本协议订立前还是本协议订立后。</dd>
            <dt>9.3</dt>
            <dd>用户同意并已充分了解本协议的条款，承诺不将已发表于本平台的信息，以任何形式发布或授权其它主体以任何方式使用（包括但限于在各类平台、媒体上使用）。</dd>
            <dt>9.4</dt>
            <dd>达咖是本平台的制作者,拥有此平台内容及资源的著作权等合法权利,受国家法律保护,有权不时地对本协议及本平台的内容进行修改，并在本平台张贴，无须另行通知用户。在法律允许的最大限度范围内，达咖对本协议及本平台内容拥有解释权。</dd>
            <dt>9.5</dt>
            <dd>除法律另有强制性规定外，未经达咖明确的特别书面许可,任何单位或个人不得以任何方式非法地全部或部分复制、转载、引用、链接、抓取或以其他方式使用本平台的信息内容，否则，达咖有权追究其法律责任。</dd>
            <dt>9.6</dt>
            <dd>本平台所刊登的资料信息（包括但不限于文字、编码、图表、标识、按钮图标、图像、肖像、声音文件片段、数字下载、数据编辑和软件），均是达咖或其内容提供者的财产，受到中华人民共和国知识产权相关法律法规的保护。本平台上所有内容的汇编是达咖的排他财产，受中国和国际版权法的保护。本平台上所有软件都是达咖或其关联公司或其软件供应商的财产，受中国和国际版权法的保护。</dd>
            <dd>您仅在符合本平台使用目的的前提下被许可浏览和使用本平台，即以个人名义浏览信息和购买供个人使用商品的目的。其他方式的使用都是被严格禁止的，包括但不限于以下方式：复制、修改、销售、传送、再版、删除、添加、展览、记入或演示本平台的内容或以其他方式部分地或整体地非法使用本平台的内容，但经达咖允许将本平台当中的资讯转发至微信朋友圈等第三方媒体的除外。</dd>
          </dl>
        </li>
        <li>
          <div class="t1">第 10 条 责任限制及不承诺担保</div>
          <dl>
            <dt>10.1</dt>
            <dd class="line strong">如果达咖平台发现或收到他人举报或投诉您违反本协议约定的，达咖平台有权不经通知随时对相关内容，包括但不限于用户资料、日志、交易记录进行审查、删除，并视情节轻重对违规账号处以包括但不限于关闭交易订单、冻结或注销用户账号、扣除账户余额等措施。</dd>
            <dd class="line strong">如您的行为使达咖及/或其关联公司遭受损失（包括自身的直接经济损失、商誉损失及对外支付的赔偿金、和解款、律师费、诉讼费等间接经济损失），您应赔偿达咖及/或其关联公司上述全部损失。</dd>
            <dd class="line strong">如您的行为使达咖及/或其关联公司遭受第三人主张权利，达咖及/或其关联公司可在对第三人承担金钱给付等义务后就全部损失向您追偿。</dd>
            <dd class="line strong">如因您的行为使得第三人遭受损失或您怠于履行调处决定，达咖出于社会公共利益保护目的，可自您的账户中扣划相应款项支付上述赔偿款项。如您的账户余额不足以支付相应款项的，您同意委托达咖使用自有资金代您支付上述款项，您应当返还该部分费用并赔偿因此造成达咖的全部损失。</dd>
            <dt>10.2</dt>
            <dd>除非另有明确的书面说明,本平台及其所包含的或以其它方式通过本平台提供给您的全部信息、内容、材料、产品（包括软件）和服务，均是在"按现状"和"按现有"的基础上提供的。</dd>
            <dt>10.3</dt>
            <dd>除非另有明确的书面说明,达咖不对本平台的运营及其包含在本平台上的信息、内容、材料、产品（包括软件）或服务作任何形式的、明示或默示的声明或担保（根据中华人民共和国法律另有规定的以外）。</dd>
            <dt>10.4</dt>
            <dd>达咖不担保本平台所包含的或以其它方式通过本平台提供给您的全部信息、内容、材料、产品（包括软件）和服务、其服务器或从本平台发出的电子信件、信息没有病毒或其他有害成分。</dd>
            <dt>10.5</dt>
            <dd>因用户违反本协议约定，导致或产生的任何第三方主张的任何索赔、要求或损失，包括合理的律师费，用户应当赔偿达咖平台及其合作方，并使之免受损害。</dd>
            <dt>10.6</dt>
            <dd>达咖平台有权依合理判断对违反有关法律法规或本协议规定的行为进行处罚并公示，对违法违规的任何用户采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，用户应承担由此而产生的一切法律责任。</dd>
            <dt>10.7</dt>
            <dd>如因不可抗力或其它本平台无法控制的原因使本平台销售系统崩溃或无法正常使用导致网上交易无法完成或丢失有关的信息、记录等，达咖会合理地尽力协助处理善后事宜，但不承担补偿、赔偿、弥补损失等法律责任。</dd>
          </dl>
        </li>
        <li>
          <div class="t1">第 11 条 协议更新及用户关注义务</div>
          <p class="line strong">根据国家法律法规变化及平台运营需要，达咖有权对本协议条款不时地进行修改，修改后的协议一旦被张贴在本平台上即生效，并代替原来的协议（即协议的更新）。更新后的协议将公布在达咖平台或以其他方式通知您，用户可随时登录查阅最新协议；同时，用户知晓并同意达咖对协议的修改权的，则用户有义务不时关注并阅读最新版的协议及平台公告。如用户不同意更新后的协议，可以且应立即停止接受达咖平台依据本协议提供的服务；如用户继续使用本平台提供的服务的，即视为同意更新修改后的协议。达咖建议您在使用本平台之前阅读本协议及本平台的公告。</p>
          <p>如果本协议中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。</p>
        </li>
        <li>
          <div class="t1">第 12 条 不可抗力及其他免责事由</div>
          <dl>
            <dt>12.1</dt>
            <dd>用户理解并确认，在使用本协议项下的服务的过程，可能会遇到不可抗力等风险因素，使本协议项下的服务发生中断。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为等。出现上述情况时，达咖平台将努力在第一时间与相关单位配合，及时进行修复，但是由此给用户或第三方造成的损失，达咖平台及合作公司在法律允许的范围内免责。</dd>
            <dt>12.2</dt>
            <dd>本协议项下的服务同大多数互联网服务一样，受包括但不限于用户原因、网络服务质量、社会环境等因素的差异影响，可能受到各种安全问题的侵扰，如他人利用用户的资料，造成现实生活中的骚扰；用户下载安装的其它软件或访问的其他网站中含有“特洛伊木马”等病毒，威胁到用户的计算机信息和数据的安全，继而影响本协议项下的服务的正常使用等等。用户应加强信息安全及使用者资料的保护意识，要注意加强密码保护，以免遭致损失和骚扰。</dd>
            <dt>12.3</dt>
            <dd class="line strong">本协议项下的服务存在因不可抗力、计算机病毒或黑客攻击、系统不稳定、用户所在位置、用户关机以及其他任何技术、互联网络、通信线路原因等造成的服务中断或不能满足用户要求的风险，因此导致的用户或第三方任何损失，达咖平台在法律允许的范围内免责。</dd>
            <dt>12.4</dt>
            <dd class="line strong">在使用本协议项下的服务过程中存在来自任何他人的包括误导性的、欺骗性的、威胁性的、诽谤性的、令人反感的或非法的信息，或侵犯他人权利的匿名或冒名的信息，以及伴随该等信息的行为，因此导致的用户或第三方的任何损失，达咖平台不承担任何责任。</dd>
            <dt>12.5</dt>
            <dd class="line strong">达咖平台需要定期或不定期地对达咖平台或相关的设备进行检修或者维护，如因此类情况而造成服务在合理时间内的中断，达咖平台无需为此承担任何责任，但达咖平台应事先进行通告。</dd>
            <dt>12.6</dt>
            <dd>达咖平台依据法律法规、本协议约定获得处理违法违规或违约内容的权利，该权利不构成达咖平台的义务或承诺，达咖平台不能保证及时发现违法违规或违约行为或进行相应处理。</dd>
            <dt>12.7</dt>
            <dd class="line strong">在任何情况下，达咖平台均不对任何间接性、后果性、惩罚性、偶然性、特殊性或刑罚性的损害，包括因用户使用达咖平台或本协议项下的服务而遭受的利润损失，承担责任(即使达咖平台已被告知该等损失的可能性亦然)。尽管本协议中可能含有相悖的规定，达咖平台对用户承担的全部责任，无论因何原因或何种行为方式，始终不超过用户因使用达咖平台提供的服务而支付给达咖平台的费用（如有)。</dd>
          </dl>
        </li>
        <li>
          <div class="t1">第 13 条 法律管辖和适用</div>
          <p class="line strong">本协议的订立、执行和解释及争议的解决均应适用在中华人民共和国大陆地区适用之有效法律（但不包括其冲突法规则）。 如发生本协议与适用之法律相抵触时，则这些条款将完全按法律规定重新解释，而其它有效条款继续有效。</p>
          <p class="line">用户因使用达咖平台服务所产生的及与达咖平台服务有关的争议，由达咖与用户协商解决。协商不成的，任何一方均可向上海市徐汇区人民法院提起诉讼。 </p>
        </li>
        <li>
          <div class="t1">第 14 条 通知的送达</div>
          <p class="line strong">达咖通过您在注册时提供的联系方式向您发出通知，其中以电子的方式发出的书面通知，包括但不限于在达咖平台公告，向您提供的联系电话发送手机短信，向您提供的电子邮件地址发送电子邮件，向您的账号发送信息、系统消息以及站内信信息，在发送成功后即视为送达；以纸质载体发出的书面通知，按照提供的联系地址交邮后的第五个自然日即视为送达。</p>
          <p class="line strong">对于您在达咖平台上因交易活动引起的任何纠纷，您同意司法机关（包括但不限于人民法院）可以通过手机短信、电子邮件等现代通讯方式或邮寄方式向您送达法律文书（包括但不限于诉讼文书）。您指定接收法律文书的手机号码、电子邮箱联系方式，司法机关向上述联系方式发出法律文书即视为送达。您指定的邮寄地址为您的法定联系地址或您提供的有效联系地址。</p>
          <p class="line strong">您同意司法机关可采取以上一种或多种送达方式向您送达法律文书，司法机关采取多种方式向您送达法律文书，送达时间以上述送达方式中最先送达的为准。</p>
          <p class="line strong">您同意上述送达方式适用于各个司法程序阶段。如进入诉讼程序的，包括但不限于一审、二审、再审、执行以及督促程序等。</p>
          <p class="line strong">您应当保证所提供的联系方式是准确、有效的，并进行实时更新。如果因提供的联系方式不确切，或不及时告知变更后的联系方式，使法律文书无法送达或未及时送达，由您自行承担由此可能产生的法律后果。</p>
        </li>
        <li>
          <div class="t1">第 15 条 其他</div>
          <dl>
            <dt>15.1</dt>
            <dd>达咖平台所有者是指在政府部门依法许可或备案的达咖平台经营主体即上海达咖文化发展有限公司。</dd>
            <dt>15.2</dt>
            <dd>达咖尊重用户和消费者的合法权利，本协议及本平台上发布的各类规则、声明等其他内容，均是为了更好的、更加便利的为用户和消费者提供服务。本平台欢迎用户和社会各界提出意见和建议，达咖将虚心接受并适时修改本协议及本平台上的各类规则。</dd>
            <dt>15.3</dt>
            <dd>本协议内容中以黑体、加粗、下划线、斜体等方式显著标识的条款，请用户着重阅读。</dd>
            <dt>15.4</dt>
            <dd>您点击本协议下方的「同意并继续」按钮即视为您完全接受本协议，在点击之前请您再次确认已知悉并完全理解本协议的全部内容。</dd>
          </dl>
        </li>
      </ul>
      <div class="time">
        <div>更新日期：2023年04月10日</div>
        <div>生效日期：2023年04月10日</div>
      <div>上海达咖文化发展有限公司</div></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'about',
  components: {},
  data() {
    return {
      dislogType: this.$enumInfo.dislogType,
    }
  },
  mounted() {},
  created() {
    this.closeDialog()
  },
  methods: {
    // 关闭弹框
    closeDialog() {
      this.dislogType.login = false
      this.dislogType.register = false
    },
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/market.css";
@import "../../../static/css/information.css";

</style>



// WEBPACK FOOTER //
// src/pages/information/useragreement.vue